import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

@Injectable({
    providedIn: 'root'
})
export class FileManagerService {

    private uri = 'plan/api/filemanager';

    
    constructor(private httpClient: HttpClient) { }

    list(requestParam: any) {
        return this.httpClient.post(this.uri + '/list', requestParam);
    }

    preview(requestParam: any) {
        return this.httpClient.post(this.uri + '/preview', requestParam);
    }

    folder(requestParam: any) {
        return this.httpClient.post(this.uri + '/folder', requestParam);
    }

    remove(requestParam: any) {
        return this.httpClient.post(this.uri + '/remove', requestParam);
    }

    rename(requestParam: any) {
        return this.httpClient.post(this.uri + '/rename', requestParam);
    }

    move(requestParam: any) {
        return this.httpClient.post(this.uri + '/move', requestParam);
    }

    version(requestParam: any) {
        return this.httpClient.post(this.uri + '/version', requestParam);
    }

    search(requestParam: any) {
        return this.httpClient.post(this.uri + '/search', requestParam);
    }

    parent(requestParam: any) {
        return this.httpClient.post(this.uri + '/parent', requestParam);
    }

    children(requestParam: any) {
        return this.httpClient.post(this.uri + '/children', requestParam);
    }

    upload(file: any, params: any) {

        const formData = new FormData();
        formData.append('file', file);

        return this.httpClient.post(this.uri + '/upload', formData, {
            params: params,
            reportProgress: true,
            observe: "events"
        });
    }

    downloadByPath(filePath: string, timestamp: number) {
        return this.httpClient.get(this.uri + '/downloadbypath?action=download&path=' + filePath + '&ts=' + timestamp);
    }

    downloadLinkByPath(filePath: string, timestamp: number) {
        return this.uri + '/downloadbypath?action=download&path=' + filePath + '&ts=' + timestamp;
    }

    downloadById(id: string) {
        return this.httpClient.get(this.uri + '/downloadbyid?action=download&id=' + id);
    }

    downloadLinkById(id: string) {
        return this.uri + '/downloadbyid?action=download&id=' + id;
    }

}
